import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { logoutUser } from "../redux/auth/actions";
import Logo from "../assets/images/logo.png";
import { Dropdown, Button, Modal } from "react-bootstrap";
import numberWithCommas from "../utils/numbersWithComma";
import Whatsapp from "../assets/images/icons/whatsapp.png";
import DepositIcon from "../assets/images/icons/deposit-icon.webp";
import DollarIcon from "../assets/images/icons/rupee.svg";
import ArrowDown from "../assets/images/icons/arrow-down.webp";
import BonusIcon from "../assets/images/icons/bonus.png";
import UserIcon from "../assets/images/icons/user.png";
import AviatorLogo from "../assets/images/icons/aviator-icon.webp";
import GiftIcon from "../assets/images/icons/gift-icon.webp";
import { AiOutlineClose } from "react-icons/ai";
import Bonuses from "../assets/images/icons/bonuses.webp";
import GamesSearchModal from "../views/components/GamesSearchModal";
import { getNotifications } from "../redux/app/actions";
import { useTranslation } from "react-i18next";
import ThemeSelector from "../views/components/ThemeSelector";

import Top from "../assets/images/icons/header/Top.webp";
import Sports from "../assets/images/icons/header/Sports.webp";
import Esports from "../assets/images/icons/header/Esports.webp";
import Casino from "../assets/images/icons/header/Casino.webp";
import Slots from "../assets/images/icons/header/Slots.webp";
import BrandGame from "../assets/images/icons/header/BrandGame.webp";
import { SportsLobbyProviders } from "../config/const";

const menuItems = [
  { name: "Top", path: "/", activeKey: "home" },
  {
    name: "Sports",
    path: `/sports-lobby/${SportsLobbyProviders.IgPixel}?lang=ru`,
    activeKey: "igPixel",
  },
  {
    name: "Esports",
    path: `/sports-lobby/${SportsLobbyProviders.IgPixel}?slug=igp-pre-match-95&lang=ru`,
    activeKey: "",
  },
  { name: "Casino", path: "/casinos/alls", activeKey: "casinos" },
  { name: "Slots", path: "/casinogames/all", activeKey: "brand-games" },
  { name: "Yildiztop", path: "/brand-games", activeKey: "brand-games" },
  // { name: "Live-Casino", path: "/livecasino", activeKey: "livecasino" },
  // { name: "Aviator", path: "casino/spribe/aviator", activeKey: "aviator" },
  // { name: "Live-games", path: "/livegames", activeKey: "livegames" },
];

const menuItemsMob = [
  { name: "Top", path: "/", activeKey: "home", icon: Top },
  {
    name: "Sports",
    path: `/sports-lobby/${SportsLobbyProviders.IgPixel}?lang=ru`,
    activeKey: "igPixel",
    icon: Sports,
  },
  {
    name: "Esports",
    path: `/sports-lobby/${SportsLobbyProviders.IgPixel}?slug=igp-pre-match-95&lang=ru`,
    activeKey: "",
    icon: Esports,
  },
  {
    name: "Casino",
    path: "/casinos/alls",
    activeKey: "casinos",
    icon: Casino,
  },
  {
    name: "Slots",
    path: "/casinogames/all",
    activeKey: "casinogames",
    icon: Slots,
  },
  {
    name: "Yildiztop",
    path: "/brand-games",
    activeKey: "brand-games",
    icon: BrandGame,
  },
];

const providers = [
  { name: "Evolution", path: "/casino/evolution", activeKey: "evolution" },
  { name: "Ezugi", path: "/casino/ezugi", activeKey: "ezugi" },
  { name: "Supernowa", path: "/casino/supernowa", activeKey: "supernowa" },
  { name: "Vivo", path: "/casino/vivo", activeKey: "vivo" },
  { name: "XPG", path: "/casino/xpg", activeKey: "xpg" },
  // {
  //   name: "Worldcasino",
  //   path: "/casino/worldcasino",
  //   activeKey: "worldcasino",
  // },
  { name: "Qtech", path: "/casino/qtech", activeKey: "qtech" },
  // {
  //   name: "Pragmatic Play",
  //   path: "/pragmaticplay",
  //   activeKey: "pragmaticplay",
  // },
  { name: "Aura", path: "/aura-games", activeKey: "aura" },
  // { name: "ALT Gaming", path: "/gap/jiliGaming", activeKey: "gap" },
  { name: "Vimplay", path: "/vimplay", activeKey: "vimplay" },
];

const headerPages = [
  "home",
  `/sports-lobby/${SportsLobbyProviders.IgPixel}`,
  "igPixel",
  "sports1",
  "casinogames",
  "livecasino",
  "?slug=live",
  "brand-games",
  "livegames",
  "casinos",
  "aviator",
  "evolution",
  "ezugi",
  "supernowa",
  "vivo",
  "xpg",
  "worldcasino",
  "qtech",
  "atlas-lobby",
  "/",
  // "spmsports",
];

const HeaderAfterLogin = () => {
  const { wallet } = useSelector((state) => state.auth);
  const isDemoUser = useSelector((state) => state?.auth?.isDemoUser);

  const dispatch = useDispatch();
  const { appDetails } = useSelector((state) => state.app);

  const location = useLocation();
  const [activePage, setActivePage] = useState("");

  const { t } = useTranslation();

  useEffect(() => {
    const matchedValue = headerPages.find(
      (f) =>
        location?.pathname.includes(f) || location?.search.includes("?slug"),
    );
    if (matchedValue) {
      setActivePage(matchedValue);
    }
  }, [location]);

  // Header SubMenu active class feature
  const isMenuItemActive = (item) => {
    const { pathname, search } = location;
    // for top tab
    if (item.activeKey === "home") {
      return pathname === "/home";
    }

    // Sports & Esports special handling
    if (pathname.startsWith("/sports-lobby/ig_pixel")) {
      if (
        search &&
        item.name === "Esports" &&
        search?.includes("igp-pre-match-95")
      )
        return true;
      if (search && item.name === "Sports" && !search?.includes("slug"))
        return true;
      return false;
    }

    // Default behavior
    return pathname === item.path;
  };

  const [isSticky, setIsSticky] = useState(false);
  const [lastScrollTop, setLastScrollTop] = useState(0);
  const [websiteNotifications, setWebsiteNotifications] = useState([]);
  const [showNotifications, setShowNotifications] = useState(true);

  useEffect(() => {
    loadNotifications();
    return () => {};
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      const scrollHeight = document.documentElement.scrollHeight;
      const clientHeight = document.documentElement.clientHeight;
      if (currentScrollTop > lastScrollTop && currentScrollTop > 0) {
        // Scrolling down
        setIsSticky(true);
      } else if (currentScrollTop <= 0) {
        // Remove sticky class when scrolled all the way up
        setIsSticky(false);
      }
      setLastScrollTop(currentScrollTop);
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [lastScrollTop]);

  const [isproviderActive, setIsproviderActive] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const inlineStyle = isproviderActive ? { overflowX: "clip" } : {};
  const handleProvidersClick = () => {
    const isMobile = window.innerWidth < 992;

    if (isMobile) {
      setShowModal(true);
      document.body.classList.add("modal-providers-aftrlgn");
      document.documentElement.style.overflow = "hidden";
    } else {
      setIsproviderActive(!isproviderActive);
    }
  };

  const handleModalClose = () => {
    setShowModal(false);
    document.body.classList.remove("modal-providers");
    document.documentElement.style.overflow = "auto";
  };

  const loadNotifications = async () => {
    // get notifications
    const notifications = await getNotifications();
    if (notifications && notifications?.data?.data) {
      setShowNotifications(true);
      setWebsiteNotifications(notifications?.data?.data);
    }
  };

  const [time, setTime] = useState("");
  useEffect(() => {
    const updateTime = () => {
      const now = new Date();

      const localTime = new Intl.DateTimeFormat("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      }).format(now);

      setTime(localTime);
    };

    updateTime();
    const interval = setInterval(updateTime, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      {(websiteNotifications.length && showNotifications && (
        <div className="marqu">
          <marquee>
            {websiteNotifications.map((notf, idx) => (
              <label style={{ marginRight: "30px" }} key={idx}>
                {notf?.content}
              </label>
            ))}
          </marquee>
          <span onClick={() => setShowNotifications(false)}>
            <AiOutlineClose />
          </span>
        </div>
      )) ||
        null}

      <header className="header aftrlgn">
        <div className="top_head">
          <div className="inner-box">
            <div className="left-section">
              <div className="bal-dpst d-md-none">
                <div className="balance">
                  <a href="/gatewaylist">+</a>
                  <span>
                    {wallet?.balance}&nbsp;<small>TRY</small>
                  </span>
                  {/* <Dropdown align="center" className="balanceDropdown">
                    <Dropdown.Toggle variant="success" id="dropdown-balance">
                      <img src={ArrowDown} alt="balance" />
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <div className="bal real">
                        <p>Main Wallet</p>
                        <div className="box">
                          <div className="amnt">
                            {numberWithCommas(wallet?.balance)}
                          </div>
                          <div className="dpst">
                            <a href="/gatewaylist">
                              <img src={DepositIcon} alt="deposit" />
                            </a>
                          </div>
                        </div>
                      </div>
                      <div className="bal cash">
                        <p>Cash</p>
                        <div className="box">
                          <div className="amnt">
                            {numberWithCommas(wallet?.cash)}
                          </div>
                        </div>
                      </div>
                      <div className="bal bonus">
                        <p>Bonus</p>
                        <div className="box">
                          <div className="amnt">
                            {numberWithCommas(wallet?.coins)}
                          </div>
                        </div>
                      </div>
                    </Dropdown.Menu>
                  </Dropdown> */}
                </div>
              </div>

              <div className="logo">
                <a href="/">
                  <img src={appDetails?.LOGO_URL} alt="Logo" height={60} />
                  {/* <img src={Logo} alt="Logo" /> */}
                </a>
              </div>

              <GamesSearchModal />
            </div>

            <div className="right-section d-none d-md-flex">
              <div className="d-none d-md-block">
                <ThemeSelector />
              </div>

              <div className="bonus">
                <a href="/bonus">
                  <img src={BonusIcon} alt="user" />
                </a>
              </div>
              <div className="bal-dpst">
                <div className="balance">
                  <span>
                    <strong>{wallet?.balance}&nbsp;</strong>
                    <Dropdown align="center" className="balanceDropdown">
                      <Dropdown.Toggle variant="success" id="dropdown-balance">
                        <img src={ArrowDown} alt="balance" />
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <div className="bal real">
                          <p>Main Wallet</p>
                          <div className="box">
                            {/* <div className="img-box">
                              <img src={DollarIcon} alt="rupee" />
                            </div> */}
                            <div className="amnt">
                              {numberWithCommas(wallet?.balance)}
                            </div>
                            {!isDemoUser && (
                              <div className="dpst">
                                <a href="/gatewaylist">
                                  <img src={DepositIcon} alt="deposit" />
                                </a>
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="bal cash">
                          <p>Cash</p>
                          <div className="box">
                            {/* <div className="img-box">
                              <img src={DollarIcon} alt="rupee" />
                            </div> */}
                            <div className="amnt">
                              {numberWithCommas(wallet?.cash)}
                            </div>
                          </div>
                        </div>
                        <div className="bal bonus">
                          <p>Bonus</p>
                          <div className="box">
                            {/* <div className="img-box">
                              <img src={DollarIcon} alt="rupee" />
                            </div> */}
                            <div className="amnt">
                              {numberWithCommas(wallet?.coins)}
                            </div>
                          </div>
                        </div>
                      </Dropdown.Menu>
                    </Dropdown>
                  </span>
                </div>
                {/* <DepositModal /> */}
                {!isDemoUser && (
                  <div className="dpst-btn">
                    <a href="/gatewaylist" className="btn">
                      Deposit
                    </a>
                  </div>
                )}
              </div>

              <Dropdown align="end" className="userDropdown">
                <Dropdown.Toggle variant="success" id="dropdown-basic">
                  <img src={UserIcon} alt="user" />
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item href="/profile">Profile</Dropdown.Item>
                  {!isDemoUser && (
                    <Dropdown.Item href="/withdraw">Withdrawal</Dropdown.Item>
                  )}
                  {!isDemoUser && (
                    <Dropdown.Item href="/gatewaylist">Deposit</Dropdown.Item>
                  )}
                  <Dropdown.Item href="/mybets">Bets History</Dropdown.Item>
                  <Dropdown.Item href="/referral">Referral</Dropdown.Item>
                  <Dropdown.Item href="/bonus">Bonus</Dropdown.Item>
                  <Dropdown.Item href="/cashier">Statement</Dropdown.Item>
                  {!isDemoUser && (
                    <Dropdown.Item href="/deposit/list">
                      Deposit History
                    </Dropdown.Item>
                  )}
                  {!isDemoUser && (
                    <Dropdown.Item href="/withdrawList">
                      Withdraw History
                    </Dropdown.Item>
                  )}
                  <Dropdown.Item
                    href="#"
                    onClick={() => dispatch(logoutUser())}>
                    Log Out
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>

              <div className="time-zone d-none d-md-block">{time}</div>
            </div>
          </div>
        </div>

        <div
          className={`bottom_head d-none d-md-block ${
            isSticky ? "sticky" : ""
          }`}>
          <div className="inner-box">
            <div className="head-links">
              <ul style={inlineStyle}>
                {menuItems.map((item) => (
                  <li key={item.name}>
                    <a
                      href={item.path}
                      className={`
                      ${isMenuItemActive(item) ? "active" : ""}
                      ${item.name === "Aviator" ? "game-logo" : ""}
                    `}>
                      <span>
                        {item.isLogo ? (
                          <img src={item.logo} alt={item.name} />
                        ) : (
                          item.name
                        )}
                      </span>
                    </a>
                  </li>
                ))}
                {/* <li className="providers">
                  <a href="javascript:void(0)" onClick={handleProvidersClick}>
                    <span>Games by provider</span>
                  </a>
                  <ul
                    className={`providers-games d-none d-md-flex ${
                      isproviderActive ? "active" : ""
                    }`}
                  >
                    {providers.map((provider) => (
                      <li key={provider.name}>
                        <a
                          href={provider.path}
                          className={
                            activePage === provider.activeKey ? "active" : ""
                          }
                        >
                          <span>{provider.name}</span>
                        </a>
                      </li>
                    ))}
                  </ul>
                </li> */}
                {/* <li className="d-none d-md-block">
                  <GamesSearchModal />
                </li> */}
                {/* <li className="providers">
                  <LanguageChange />
                </li> */}
                {/* <li className="providers">
                  <a
                    href="/atlas-lobby"
                    className={activePage === "atlas-lobby" ? "active" : ""}
                  >
                    <span>Sportsbook 2</span>
                  </a>
                </li> */}
              </ul>
            </div>
          </div>
        </div>

        <div className="bottom_head d-md-none">
          <div className="head-links">
            <ul>
              {menuItemsMob.map((item) => (
                <li key={item.name}>
                  <a
                    href={item.path}
                    className={`
                    ${isMenuItemActive(item) ? "active" : ""}
                  `}>
                    <img src={item.icon} alt={item.name} />
                    <span>{item.name}</span>
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <Modal
          className="providers-list"
          show={showModal}
          onHide={handleModalClose}
          size="sm"
          aria-labelledby="contained-modal-title-vcenter">
          <Modal.Body>
            <div className="providers-link">
              <ul>
                {providers.map((provider) => (
                  <li key={provider.name}>
                    <a
                      href={provider.path}
                      className={
                        activePage === provider.activeKey ? "active" : ""
                      }>
                      <span>{provider.name}</span>
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </Modal.Body>
        </Modal>
      </header>
    </>
  );
};

export default HeaderAfterLogin;
